import { domain } from 'modules/data';

export const createUser = (email: string): domain.User => ({
    id: email.toLowerCase(),
    databaseId: undefined,
    userEmail: email,
    firstName: '',
    lastName: '',
});
